import { loadView } from '@/router'
import accounts from './accounts'
import pickups from './pickups'
import campaigns from './campaigns'
import enquiries from './enquiries'

export default [
  {
    path: 'customer-service',
    name: 'customerservice',
    component: loadView('Application/CustomerService'),
    redirect: {
      name: 'customerservice-dashboard'
    },
    showInAlfred: true,
    alfredTitle: 'Customer Service - Dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'customerservice-dashboard',
        component: loadView('Application/CustomerService/Dashboard')
      },
      ...accounts,
      ...pickups,
      ...campaigns,
      ...enquiries
    ]
  }
]
